import { render, staticRenderFns } from "./Stadistics.vue?vue&type=template&id=0665915a&scoped=true"
import script from "./Stadistics.vue?vue&type=script&lang=js"
export * from "./Stadistics.vue?vue&type=script&lang=js"
import style0 from "./Stadistics.vue?vue&type=style&index=0&id=0665915a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665915a",
  null
  
)

export default component.exports